import { SelectFields } from '@repo/toolkit/types'

import { EnrollmentPickup } from '../../models/enrollment/enrollment-pickup'
import { FieldsSelector } from '../../utils'

export const enrollmentPickupBaseFields = [
  'id',
  'person',
  'firstName',
  'lastName',
  'phoneNumber'
] as const satisfies FieldsSelector<EnrollmentPickup>

export type EnrollmentPickupBase = SelectFields<
  EnrollmentPickup,
  typeof enrollmentPickupBaseFields
>
